import React from 'react';
import axios from 'axios';
import { getURLParams } from '../helpers';
import AuthHeader from './AuthHeader';
import StyledContainer from './StyledContainer';
import AuthFooter from './AuthFooter';

const NewPassword: React.FC = () => {
  const [password1, setPassword1] = React.useState('');
  const [password2, setPassword2] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');

  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (password1 !== password2) {
      setErrorMessage('Passwords do not Match');
      return;
    }

    const { email = '', hash: resetHash } = getURLParams();

    try {
      if (!email) {
        setErrorMessage(
          `Please retry the password reset from the latest password reset email`,
        );
        return;
      }
      await axios.post('/new_password', {
        email,
        resetHash,
        password: password1,
      });
      window.location.href = '/new_password_success';
    } catch (err) {
      if (err.response?.status === 403) {
        setErrorMessage(
          `This is an invalid/outdated link. Please use the reset link from the latest password reset email`,
        );
      } else if (err.response?.status === 400) {
        setErrorMessage(
          `User not found with email: ${email}. Please retry the password reset with a correct email`,
        );
      } else {
        setErrorMessage(
          'Unknown error occurred. Please re-send the password reset email',
        );
      }
    }
  };

  return (
    <StyledContainer>
      <AuthHeader />
      <div className="row">
        <div className="col-md-12">
          <div className="text-center m-b-md">
            <h3>Reset Password</h3>
          </div>
          <div className="hpanel">
            <div className="panel-body">
              <form onSubmit={submit}>
                <div className="row">
                  <div className="form-group col-md-8 col-md-offset-2">
                    <label>Enter password</label>
                    <input
                      type="password"
                      className="form-control"
                      value={password1}
                      onChange={({ target: { value } }) => setPassword1(value)}
                      placeholder="Password"
                      required
                    />
                    <label>Confirm password</label>{' '}
                    {errorMessage && (
                      <label className="error">{errorMessage}</label>
                    )}
                    <input
                      type="password"
                      className="form-control"
                      value={password2}
                      onChange={({ target: { value } }) => setPassword2(value)}
                      placeholder="Repeat Password"
                      required
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4 col-md-offset-2">
                    <input
                      type="submit"
                      className="btn btn-primary btn-block"
                    />
                  </div>
                  <div className="col-md-4">
                    <a href="/" className="btn btn-default btn-block">
                      Back to login
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <AuthFooter />
    </StyledContainer>
  );
};

export default NewPassword;
